import React from "react";
import "./ValentinesModal.scss";
import valentinesBannerMobile from "../../assets/images/valentinesBannerMobile.png"
import valentinesBannerWeb from "../../assets/images/valentinesBannerWeb.png"
import close from "../../assets/icons/close-black.svg"
import menu from "../../assets/menus/ValentineDaySetMenu.pdf"

const ValentinesModal = ({ onClose }) => {
    return (
        <div className="ValentinesModaloverlay" onClick={onClose}>
            <div className="ValentinesModalbox" onClick={(e) => e.stopPropagation()}
                style={{ backgroundImage: `${window?.screen?.width < 900 ? `url(${valentinesBannerMobile})` : `url(${valentinesBannerWeb})`}` }}>
                <div className="ValentinesModalbox-close" onClick={onClose}>
                    <img alt="" src={close} className="ValentinesModalbox-close-ic" />
                </div>
                <div className="ValentinesModalbox-button"
                    onClick={() => {
                        window.open(menu, "_blank", "noopener,noreferrer");
                        onClose()
                    }}>GO TO MENU</div>
            </div>
        </div>
    );
}
export default ValentinesModal
